import { gisService } from "@/utils/request";
import { getStorage, setStorage } from "@/utils/storage";
import {
  getGisTokenByPost,
  getGisSnTokenByPost,
} from "@/api/request/snkd.produce";
const isIpReg =
  /^((?:(?:25[0-5]|2[0-4]\d|[01]?\d?\d)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d?\d))$/;
// 本地开发ip地址登录 通过gis服务接口自行获取  线上环境通过api接口获取token
const isDevEnv = isIpReg.test(window.location.hostname);
const shWeixingTile =
  "https://mapserver.nyncw.sh.gov.cn/OneMapServer/rest/services/202301sat_dom_tdt/MapServer";
let getTokenLock; //防止同时调用获取token接口
/**
 * @description: 获取token
 * @param {string} type shanghai/area  用于区分 上海还是全国区域
 * @param {string} serverUrl 需要申请token的服务地址
 * @param {fn} callback 点击清除按钮后的回调
 * @return: 无
 */
function getGisToken(type, serverUrl) {
  let getTokenParam = getTokenParamfn(type, serverUrl);
  if (isDevEnv) {
    //通过gis服务接口自行获取token
    return getGisTokenByGisServe(type, getTokenParam);
  } else {
    // 通过我们的服务中转接口获取token
    return getGisTokenByOurServe(type);
  }
}
function getTokenParamfn(type, serverUrl) {
  let getTokenParam = {};
  switch (type) {
    case "shanghai":
      var serveTileUrl = serverUrl || shWeixingTile;
      var reg = /^http(s)?:\/\/(.*?)\//;
      getTokenParam.getTokenUrl =
        reg.exec(serveTileUrl)[0] +
        "RemoteTokenServer?request=getToken&username=zuoan&password=ZAXH666zaxhcn";
      break;
    default:
      getTokenParam.getTokenUrl =
        serverUrl.split("arcgis")[0] + "arcgis/tokens/";
      getTokenParam.username = "snkoudai_arcgis";
      getTokenParam.password = "1qazXSW@<>?";
      break;
  }
  return getTokenParam;
}
function getGisTokenByGisServe(type, getTokenParam) {
  if (type === "shanghai") {
    return shGetGisTokenByGisServe(getTokenParam);
  }
  return snkdGetGisTokenByGisServe(type, getTokenParam);
}
function shGetGisTokenByGisServe(getTokenParam) {
  let { getTokenUrl } = getTokenParam;
  if (!getTokenUrl) return;
  return new Promise((resolve) => {
    var temptoken = "";
    var effectTime = 60 * 24;
    const windowOrigin = window.location.origin;
    var nowtime = Date.parse(new Date()) / 1000;
    var devgistoken = getStorage("sh_gistoken");
    if (devgistoken) {
      let { origin, expiration, token } = devgistoken;
      if (origin === windowOrigin && nowtime < expiration + 60 * 60 * 12) {
        // 12小时内
        temptoken = token;
        resolve(temptoken);
        return;
      }
    }
    gisService({
      url:
        getTokenUrl +
        "&clientid=ref." +
        windowOrigin +
        "/&expiration=" +
        effectTime,
      method: "get",
    })
      .then((result) => {
        if (result) {
          temptoken = result.replace(/[\s]*/g, "");
          var tokendata = {
            origin: windowOrigin,
            expiration: nowtime,
            token: temptoken,
          };
          setStorage("sh_gistoken", tokendata);
        }
        resolve(temptoken);
      })
      .catch((error) => {
        console.log("error" + JSON.stringify(error));
        resolve();
      });
  });
}
function snkdGetGisTokenByGisServe(type, getTokenParam) {
  let { getTokenUrl, username, password } = getTokenParam;
  if (!getTokenUrl || !username || !password) return;
  return new Promise((resolve) => {
    var temptoken = "";
    var effectTime = 60 * 24;
    var reg = /^http(s)?:\/\/(.*?)\//;
    let windowOrigin = reg.exec(getTokenUrl)[2];
    var nowtime = Date.parse(new Date()) / 1000;
    var devgistoken = getStorage(type + "_gistoken");
    if (devgistoken) {
      let { origin, expiration, token } = devgistoken;
      if (
        origin === windowOrigin &&
        nowtime < expiration + 60 * 60 * 12 &&
        token
      ) {
        // 12小时内
        temptoken = token;
        resolve(temptoken);
        return;
      }
    }
    gisService({
      url: getTokenParam.getTokenUrl,
      method: "post",
      dataType: "json",
      data: {
        username: username,
        password: password,
        referer: windowOrigin,
        expiration: effectTime,
        f: "json",
      },
    })
      .then((result) => {
        if (result) {
          temptoken = result.token;
          var tokendata = {
            origin: windowOrigin,
            expiration: nowtime,
            token: temptoken,
          };
          setStorage(type + "_gistoken", tokendata);
        }
        resolve(temptoken);
      })
      .catch((result) => {
        console.log("error" + JSON.stringify(result));
        resolve();
      });
  });
}
function getGisTokenByOurServe(type) {
  if (type === "shanghai") {
    return getShTokenByPost();
  }
  return getSnkdTokenByPost();
}
//api 上海获取token
async function getShTokenByPost() {
  const res = await getGisTokenByPost();
  if (res.respCode == 0 && res.obj) {
    return res.obj.replace(/[\s]*/g, "");
  } else {
    layer.msg(res.resDesc);
    return "";
  }
}
//api 神农口袋发布区域服务 获取token
async function getSnkdTokenByPost() {
  const res = await getGisSnTokenByPost();
  if (res.respCode == 0 && res.obj) {
    return res.obj.replace(/[\s]*/g, "");
  } else {
    layer.msg(res.resDesc);
    return "";
  }
}
// 防止多次同时调用本函数
function _getGisToken(...args) {
  return new Promise((resolve) => {
    if (getTokenLock) {
      return resolve(getTokenLock);
    }
    getTokenLock = new Promise((next) => {
      getGisToken(...args).then((ret) => {
        getTokenLock = null;
        next(ret);
      });
    });
    resolve(getTokenLock);
  });
}
export default _getGisToken;
